import { LANGS } from './utils/constants';
import NearMeIcon from '@material-ui/icons/NearMe';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { getLabelDisplayLangFromLabel, getLabelTextFromLabel } from './utils/utils';
import AccessibleTooltip from './AccessibleTooltip';

class BasicLangChip extends React.Component {

    render() {

        const { label, classes, defaultLang, isReadOnly, viewLang, onClick, deprecated, deleted, compact, superCompact,
            additionalIcon, disabled, tooltip,
            onDelete, id, invalid, highlight, additionalAvatar, annotated, dataTest } = this.props;

        const displayLang = getLabelDisplayLangFromLabel(label, viewLang, defaultLang);
        const text = getLabelTextFromLabel(label, id, displayLang);

        const isLongLang = displayLang.length > 2;
        const style = isLongLang ?
            {
                width: '40px', borderRadius: '16px',
                ...(viewLang && displayLang !== viewLang) ? { backgroundColor: '#CA4F0C' } : { backgroundColor: '#01579B' }
            }
            :
            {
                ...(viewLang && displayLang !== viewLang) ? { backgroundColor: '#CA4F0C' } : { backgroundColor: '#01579B' }
            };

        let toolTipTitle = tooltip || id;

        return (
            <Chip
                disabled={disabled}
                data-test={invalid ? "invalid-link" : dataTest}
                data-deleted={deleted ? true : null}
                data-deprecated={deprecated ? true : null}
                data-status={
                    deleted ?
                        "deleted"
                        :
                        deprecated ?
                            "deprecated"
                            :
                            invalid ?
                                "invalid"
                                :
                                highlight ?
                                    "highlight"
                                    :
                                    null}
                color="primary"
                className={superCompact ?
                    additionalIcon ?
                        classes.noMarginChipAdditional
                        :
                        classes.noMarginChip
                    :
                    compact ?
                        additionalIcon ?
                            classes.compactChipAdditional
                            :
                            classes.compactChip
                        :
                        additionalIcon ?
                            classes.compactChipAdditional
                            :
                            classes.chip
                }
                style={
                    {
                        ...(annotated) && {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 10
                        },
                        ...(highlight) && { backgroundColor: '#767676' },
                        ...(invalid) && { backgroundColor: '#CA4F0C' },
                        ...(deprecated) && { backgroundColor: '#CA4F0C' },
                        ...(deleted) && { backgroundColor: '#DD2C00' }
                    }
                }
                avatar={<Tooltip
                    interactive={true}
                    title={LANGS[displayLang] ?
                        LANGS[displayLang][defaultLang] ?
                            LANGS[displayLang][defaultLang]
                            :
                            LANGS[displayLang]["en"]
                        :
                        "Unknown"}>
                    <Avatar style={style} data-test="language-code">{displayLang === "und" ? "None" : displayLang}</Avatar>
                </Tooltip>}
                onClick={onClick}
                onKeyDown={(ev) => {
                    if (ev.key === "Enter") {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onClick(ev);
                    }
                }}
                onDelete={!isReadOnly && onDelete ? onDelete : null}
                label={
                    <AccessibleTooltip
                        title={
                            <span>
                                {toolTipTitle}
                            </span>
                        }
                        interactive={true}>
                        {additionalIcon ?
                            <span data-test="chip-text">
                                <span
                                    data-test="additional-icon"
                                    style={{
                                        display: 'inline-block',
                                        transform: 'translateY(5px)'
                                    }}>
                                    {additionalAvatar}
                                </span>
                                <span
                                    style={{
                                        marginLeft: 4
                                    }}>
                                    {text}
                                </span>
                            </span>
                            :
                            <span data-test="chip-text">{text}</span>
                        }
                    </AccessibleTooltip>
                } />
        );
    }
}

BasicLangChip.defaultProps = {
    invalid: false,
    highlight: false,
    deleted: false,
    disabled: false,
    deprecated: false,
    annotated: false,
    compact: false,
    superCompact: false,
    dataTest: "link",
    // Indicates if additional avatar should be displayed
    additionalIcon: false,
    additionalAvatar: <NearMeIcon data-test="near-me" fontSize="small" />
};

BasicLangChip.propTypes = {
    dataTest: PropTypes.string,
    additionalIcon: PropTypes.bool,
    annotated: PropTypes.bool,
    additionalAvatar: PropTypes.object,
    highlight: PropTypes.bool,
    deprecated: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    deleted: PropTypes.bool,
    tooltip: PropTypes.object,
    isReadOnly: PropTypes.bool,
    graph: PropTypes.string,
    compact: PropTypes.bool,
    superCompact: PropTypes.bool,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
    label: PropTypes.object,
    invalid: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    classes: PropTypes.object
};

export default withStyles(styles)(BasicLangChip);